<div class="board-map">
  <div class="map-skeleton" *ngIf="mapLoading" aria-label="Loading map">
    <span class="skeleton map-skeleton-blob blob-1"></span>
    <span class="skeleton map-skeleton-blob blob-2"></span>
    <span class="skeleton map-skeleton-blob blob-3"></span>
    <span class="skeleton map-skeleton-blob blob-4"></span>
    <span class="skeleton map-skeleton-blob blob-5"></span>
    <span class="map-skeleton-caption">Loading sentiment map…</span>
  </div>

  <div #mapContainer class="map-container"></div>
  <div class="map-legend">
    <div class="map-legend-scale">
      <span class="map-legend-label">Negative</span>
      <div class="map-legend-track">
        <span>0%</span>
        <span>50%</span>
        <span>100%</span>
      </div>
      <span class="map-legend-label">Positive</span>
    </div>

    <div class="sentiment-filter" [class.active]="sentimentFilterActive">
      <span class="sentiment-filter-title">Sentiment range</span>
      <div class="range-slider">
        <div class="range-track"></div>
        <div
          class="range-fill"
          [style.left.%]="sentimentMin"
          [style.right.%]="100 - sentimentMax"
        ></div>
        <input
          type="range"
          class="range-input"
          min="0"
          max="100"
          step="1"
          [value]="sentimentMin"
          (input)="onSentimentMinChange($any($event.target).value)"
          aria-label="Minimum sentiment"
        />
        <input
          type="range"
          class="range-input"
          min="0"
          max="100"
          step="1"
          [value]="sentimentMax"
          (input)="onSentimentMaxChange($any($event.target).value)"
          aria-label="Maximum sentiment"
        />
      </div>
      <span class="sentiment-filter-value">
        {{ sentimentMin }}%&ndash;{{ sentimentMax }}%
      </span>
      <button
        type="button"
        class="sentiment-filter-reset"
        [style.visibility]="sentimentFilterActive ? 'visible' : 'hidden'"
        [disabled]="!sentimentFilterActive"
        (click)="resetSentimentRange()"
      >
        Reset
      </button>
    </div>
  </div>
</div>

<app-market-detail-panel
  [entity]="selectedCategory"
  [sentimentParams]="sentimentParams"
  (closed)="closePanel()"
></app-market-detail-panel>
